import React from "react";
import cl from "./stayle.module.scss";

export const Home = () => {
  return <div className={cl.box}>Home</div>;
};
